module.exports = __webpack_public_path__ + "j.no1.9904ce31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/j.no1.jpg
// module id = U/ZV
// module chunks = 0